import IntroPage from "../IntroPage/IntroPage";
import PartnersPage from "../PartnersPage/PartnersPage";
import EcoDesignPage from "../EcoDesignPage/EcoDesignPage";
import AIPage from "../AIPage/AIPage";
import EconomySwitch from "../../Components/EconomySwitch/EconomySwitch";
import React from "react";
import "./MainPage.style.css";
import StrategyPage from "../StrategyPage/StrategyPage";

const MainPage = (props) => {
  const { content, setContent, economyType, setEconomyType } =
    props.AppStateService;
  const { view, activeCard, circularEconomyState, onChangeEconomySwitch } =
    props;

  let toggleVisibility = {
    Intro: true,
    EcoDesign: true,
    Strategies: true,
    Partners: false,
    AI: false,
  };

  let getView = () => {
    if (view === "Intro") {
      return (
        <IntroPage
          AppStateService={{ content, setContent, economyType, setEconomyType }}
          activeCard={activeCard}
          circularEconomyState={circularEconomyState}
          onChangeEconomySwitch={onChangeEconomySwitch}
        />
      );
    } else if (view === "EcoDesign") {
      return (
        <EcoDesignPage
          AppStateService={{ content, setContent, economyType }}
          circularEconomyState={circularEconomyState}
          onChangeEconomySwitch={onChangeEconomySwitch}
        />
      );
    } else if (view === "Strategies") {
      return (
        <StrategyPage
          AppStateService={{ content, setContent, economyType, setEconomyType }}
          circularEconomyState={circularEconomyState}
          onChangeEconomySwitch={onChangeEconomySwitch}
        />
      );
    } else if (view === "Partners") {
      return <PartnersPage />;
    } else if (view === "AI") {
      return <AIPage onChangeView={props.onChangeView} />;
    }
  };

  return <div className="Page main-page">{getView()}</div>;
};

export default MainPage;
